import { posConfigurationApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const POS_CONFIGURATIONS_ACTION_TYPE = createNamedActions('posConfigurations', {
  GET_LIST: 'GET_LIST',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  SET_DEFAULT: 'SET_DEFAULT',
});

export const getPosConfigurationsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await posConfigurationApi.getPosConfigurations();

  return dispatch({
    type: POS_CONFIGURATIONS_ACTION_TYPE.GET_LIST,
    payload: data,
  });
});

export const createPosConfigurationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await posConfigurationApi.createPosConfiguration(params);

  return dispatch({
    type: POS_CONFIGURATIONS_ACTION_TYPE.CREATE,
    payload: data,
  });
});

export const updatePosConfigurationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await posConfigurationApi.updatePosConfiguration(params);

  return dispatch({
    type: POS_CONFIGURATIONS_ACTION_TYPE.UPDATE,
    payload: data,
  });
});

export const deletePosConfigurationAction = catchAsyncActionError(({ id }) => async dispatch => {
  await posConfigurationApi.deletePosConfiguration({ id });

  return dispatch({
    type: POS_CONFIGURATIONS_ACTION_TYPE.DELETE,
    payload: { id },
  });
});

export const setPosConfigurationDefaultAction = catchAsyncActionError(
  ({ id }) =>
    async dispatch => {
      await posConfigurationApi.setPosConfigurationDefault({ id });

      return dispatch({
        type: POS_CONFIGURATIONS_ACTION_TYPE.SET_DEFAULT,
        payload: { id },
      });
    },
);

export const setDomainDefaultAction = catchAsyncActionError(({ id, domainName }) => async () => {
  await posConfigurationApi.setDomainDefault({ id, domainName });

  return { domainName };
});

export const uploadPosConfigurationImageAction = catchAsyncActionError(
  ({ id, type, formData }) =>
    async () => {
      const { data } = await posConfigurationApi.uploadPosConfigurationImage({
        id,
        type,
        formData,
      });

      return { data, type };
    },
);

export const uploadPosConfigurationDocumentAction = catchAsyncActionError(
  ({ id, type, formData }) =>
    async () => {
      const { data } = await posConfigurationApi.uploadPosConfigurationDocument({
        id,
        type,
        formData,
      });

      return { data, type };
    },
);

export const uploadPosConfigurationStepIconAction = catchAsyncActionError(
  ({ stepKey, formData }) =>
    async () => {
      const { data } = await posConfigurationApi.uploadPosConfigurationStepIcon({
        stepKey,
        formData,
      });

      return { data, stepKey };
    },
);

export const getPosConfigurationAction = catchAsyncActionError(({ id }) => async () => {
  const { data } = await posConfigurationApi.getPosConfiguration({ id });

  return data;
});

export const getPosConfigurationDomainsAction = catchAsyncActionError(({ id }) => async () => {
  const { data } = await posConfigurationApi.getPosConfigurationDomains({ id });

  return data;
});

export const assignPosConfigurationDomainAction = catchAsyncActionError(
  ({ id, domainName }) =>
    async () => {
      const { data } = await posConfigurationApi.assignPosConfigurationDomain({ id, domainName });

      return data;
    },
);

export const removePosConfigurationDomainAction = catchAsyncActionError(
  ({ id, domainName }) =>
    async () => {
      await posConfigurationApi.removePosConfigurationDomain({ id, domainName });

      return { domainName };
    },
);

export const getFormBundleCriteriaAction = catchAsyncActionError(({ id }) => async () => {
  const { data } = await posConfigurationApi.getFormBundleCriteria({ id });

  return data;
});

export const createFormBundleCriteriaAction = catchAsyncActionError(({ id, body }) => async () => {
  const { data } = await posConfigurationApi.createFormBundleCriteria({ id, body });

  return data;
});

export const updateFormBundleCriteriaAction = catchAsyncActionError(
  ({ id, criteriaId, body }) =>
    async () => {
      const { data } = await posConfigurationApi.updateFormBundleCriteria({ id, criteriaId, body });

      return data;
    },
);

export const deleteFormBundleCriteriaAction = catchAsyncActionError(
  ({ id, criteriaId }) =>
    async () => {
      await posConfigurationApi.deleteFormBundleCriteria({ id, criteriaId });

      return { criteriaId };
    },
);
